module.exports = __webpack_public_path__ + "media/images/icons/plus-rounded-abebafc12024c61d79c59c198a22fe66.svg";